// eventBus.js
import { reactive } from "vue";

export const EventBus = reactive({
  selectedSubtype: "",
  selectedServiceInfo: "", // 3rd-level leaf (serviceTypeInfo) selected from the nav mega-menu
  selectedLocation: "",
  selectedDistance: "", // Distance in miles for nearby search
  resetFilters: false,
  selectedSortBy: "",
  selectedServiceType: "",
  userInteracted: false,  
  comingFromMenu: false,
  messageReadRefresh: false, // Flag to trigger message count refresh
  openAdvanceFilter: false,
  selectedCountryName: "", // <-- Add this line
  globalLoginSuccess: false, // Flag to trigger global login refresh
  searchQuery: "", // Free-text search from nav bar or hero "What" field
  searchGeo: null, // {lat, lng, label} — geocoded hero "Where" for the AI search path; explicit geo overrides AI-parsed city/state
  parsedIntent: null, // AI-parsed search intent { serviceType1, serviceType2, city, state, freeText }
  suppressNextAutoSearch: false, // When true, AdvanceFilter watchers sync UI but skip the next auto fetch
  restoreInProgress: false, // When true, Views is restoring saved state (back-from-detail) — AdvanceFilter must not run its own searches
  withPhotosOnly: false, // Advanced-filter toggle — false = All Listings (default), true = Photos Only
  postAdRequest: false, // Toggled to ask Navigation to open the "Post Free Ad" flow (login check + PostModal)
  requestPostAd() {
    this.postAdRequest = !this.postAdRequest;
  },
  setSubtype(subtype) {
    this.selectedSubtype = subtype;
    // clear any previously selected main category so menu-driven selection isn't masked
    this.selectedServiceType = "";
    // clear any 3rd-level leaf — a sub-category selection shows the whole sub-category
    this.selectedServiceInfo = "";
    this.comingFromMenu = true;
  },
  // 3rd-level leaf selection (e.g. "Single Family Homes"). Scopes results to the
  // exact serviceTypeInfo value. Clears category/subtype so the leaf is the only
  // active scope (getDashboardData prefers serviceTypeInfo when present).
  setServiceInfo(info) {
    this.selectedServiceInfo = info;
    this.selectedServiceType = "";
    this.selectedSubtype = "";
    this.comingFromMenu = true;
  },
  setServiceType(type) {
  this.selectedServiceType = type;
  // clear any previously selected subtype so a category selection shows the
  // whole category (symmetry with setSubtype, which clears selectedServiceType)
  this.selectedSubtype = "";
  this.selectedServiceInfo = "";
  this.comingFromMenu = true;
},

  setLocation(location) {
    this.selectedLocation = location;
    this.comingFromMenu = true;
     this.openAdvanceFilter = true;
  },
  setDistance(distance) {
    this.selectedDistance = distance;
    this.comingFromMenu = true;
  },
  triggerReset() {
    this.resetFilters = true;
  },
  setSortBy(sort) {
    this.selectedSortBy = sort;
    this.comingFromMenu = true;
  },
  markNavigation() {
    this.comingFromMenu = true;
  },
  notifyMessageRead() {
    // Toggle flag to trigger watchers that listen for this event
    this.messageReadRefresh = !this.messageReadRefresh;
  },
  notifyGlobalLogin() {
    this.globalLoginSuccess = !this.globalLoginSuccess;
  },
  setSearchQuery(query, geo = null) {
    this.searchQuery = query;
    // Always assign (even null) so geo-less callers like the nav bar clear any stale hero geo
    this.searchGeo = geo;
    this.selectedServiceType = "";
    this.selectedSubtype = "";
    this.selectedServiceInfo = "";
    this.comingFromMenu = true;
  },
  clearSearchQuery() {
    this.searchQuery = "";
    this.searchGeo = null;
    this.parsedIntent = null;
  },
});
